
export const FETCH_ATTRIBUTES_AND_PRODUCTS_SAGA = "FETCH_ATTRIBUTES_AND_PRODUCTS_SAGA";
export const FETCH_ATTRIBUTES_AND_PRODUCTS_PROCESS = "FETCH_ATTRIBUTES_AND_PRODUCTS_PROCESS";
export const FETCH_ATTRIBUTES_AND_PRODUCTS_SUCCESS = "FETCH_ATTRIBUTES_AND_PRODUCTS_SUCCESS";
export const FETCH_ATTRIBUTES_AND_PRODUCTS_ERROR = "FETCH_ATTRIBUTES_AND_PRODUCTS_ERROR";

export const FETCH_INFINITY_SCROLL_ATTRIBUTE_GROUP_SAGA = "FETCH_INFINITY_SCROLL_ATTRIBUTE_GROUP_SAGA";
export const FETCH_INFINITY_SCROLL_ATTRIBUTE_GROUP_SUCCESS = "FETCH_INFINITY_SCROLL_ATTRIBUTE_GROUP_SUCCESS";
export const CLEAR_ATTRIBUTE_GROUP_STATE = "CLEAR_ATTRIBUTE_GROUP_STATE";

export const ADD_ATTRIBUTE_GROUP_SAGA = "ADD_ATTRIBUTE_GROUP_SAGA";
export const ADD_ATTRIBUTE_GROUP = "ADD_ATTRIBUTE_GROUP";
export const ADD_ATTRIBUTE_GROUP_SUCCESS = "ADD_ATTRIBUTE_GROUP_SUCCESS";
export const ADD_ATTRIBUTE_GROUP_ERROR = "ADD_ATTRIBUTE_GROUP_ERROR";

export const ADD_ATTRIBUTE_TO_ATTRIBUTE_GROUP_SAGA = "ADD_ATTRIBUTE_TO_ATTRIBUTE_GROUP_SAGA";
export const ADD_PRODUCT_TO_ATTRIBUTE_GROUP_SAGA = "ADD_PRODUCT_TO_ATTRIBUTE_GROUP_SAGA";
export const EDIT_ATTRIBUTE_GROUP_SAGA = "EDIT_ATTRIBUTE_GROUP_SAGA";


export const FETCH_ATTRIBUTE_GROUP_SAGA = "FETCH_ATTRIBUTE_GROUP_SAGA";
export const UPDATE_ATTRIBUTE_GROUP_SAGA = "UPDATE_ATTRIBUTE_GROUP_SAGA";
export const UPDATE_ATTRIBUTE_GROUP_PROCESS = "UPDATE_ATTRIBUTE_GROUP_PROCESS";
export const UPDATE_ATTRIBUTE_GROUP_ERROR = "UPDATE_ATTRIBUTE_GROUP_ERROR";
export const FETCH_EXIST_ATTRIBUTE_GROUP_SUCCESS = "FETCH_EXIST_ATTRIBUTE_GROUP_SUCCESS";
export const FETCH_ATTRIBUTE_GROUP_DETAIL_SAGA = "FETCH_ATTRIBUTE_GROUP_DETAIL_SAGA";

export const FETCH_ATTRIBUTES_DETAIL_SUCCESS = "FETCH_ATTRIBUTES_DETAIL_SUCCESS";

export const CLEAR_ATTRIBUTE_STATE = "CLEAR_ATTRIBUTE_STATE";

export const FETCH_ATTRIBUTE_GROUP_PRODUCTS_SAGA = "FETCH_ATTRIBUTE_GROUP_PRODUCTS_SAGA";
export const FETCH_ATTRIBUTES_GROUP_PRODUCTS_PROCESS = "FETCH_ATTRIBUTES_GROUP_PRODUCTS_PROCESS";
export const FETCH_ATTRIBUTES_GROUP_PRODUCTS_SUCCESS = "FETCH_ATTRIBUTES_GROUP_PRODUCTS_SUCCESS";
export const FETCH_ATTRIBUTES_GROUP_PRODUCTS_ERROR = "FETCH_ATTRIBUTES_GROUP_PRODUCTS_ERROR";
